import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import ConvertCollectedFormDialog from 'FormsUI/components/creation/ConvertCollectedFormDialog';
import { FORM_OBJECT_TYPE, PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { FORMS_WRITE } from 'FormsUI/constants/Scopes';
import { useGetsFoldersByIdsQuery } from '../../../../../../../../__generated__/chirp/com/hubspot/framework/folders/rpc/FoldersRpc.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const convertNonHSFormAction = {
  id: 'convert',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.table.collectedForms.actions.convertForm"
  }),
  actionGroup: 4,
  orderInActionGroup: 0,
  displayPermissions: {
    custom: ({
      crmObject,
      nonCrmObject
    }) => {
      const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
      return Boolean(nonCrmObject && nonCrmObject.type === 'DASHBOARD' && formType === FormTypes.CAPTURED);
    }
  },
  enablePermissions: {
    scopes: [FORMS_WRITE]
  },
  DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "permissions.disallowed"
  }),
  ModalOrPanel: ({
    crmObject,
    onClose
  }) => {
    var _data$results;
    const formGuid = getPropertyValue(crmObject, PROPERTIES.FORM_ID) || '';
    const folderId = getPropertyValue(crmObject, PROPERTIES.FOLDER_ID);
    const {
      data
    } = useGetsFoldersByIdsQuery({
      variables: {
        enabledObjectTypeId: FORM_OBJECT_TYPE,
        folderIds: folderId ? [parseInt(folderId, 10)] : []
      },
      skip: !folderId
    });
    const originFolderId = data === null || data === void 0 || (_data$results = data.results) === null || _data$results === void 0 || (_data$results = _data$results[0]) === null || _data$results === void 0 || (_data$results = _data$results.properties) === null || _data$results === void 0 || (_data$results = _data$results[PROPERTIES.FOLDER_ORIGIN_ID]) === null || _data$results === void 0 || (_data$results = _data$results.versions) === null || _data$results === void 0 || (_data$results = _data$results[0]) === null || _data$results === void 0 ? void 0 : _data$results.value;
    return /*#__PURE__*/_jsx(ConvertCollectedFormDialog, {
      guid: formGuid,
      currentFolderId: originFolderId,
      onClose: onClose
    });
  }
};
export default convertNonHSFormAction;